import * as React from "react";

function SvgIconFeatherUser(props) {
  return (
    <svg width={23.333} height={26} {...props}>
      <g
        data-name="Icon feather-user"
        fill="none"
        stroke="#333"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          data-name="Caminho 51"
          d="M22.333 25v-2.667A5.333 5.333 0 0017 17H6.333A5.333 5.333 0 001 22.333V25"
        />
        <path
          data-name="Caminho 52"
          d="M17 6.333A5.333 5.333 0 1111.666 1 5.333 5.333 0 0117 6.333z"
        />
      </g>
    </svg>
  );
}

export default SvgIconFeatherUser;
